import Axios from "axios";
import { takeLatest, put, call } from 'redux-saga/effects';
import { AUTH_SERVER } from '../../../config'
import {
    THEODORE_LOGIN,
    loginSuccess,
    loginFailure
} from './action';

export function* theoLogin(action) {
    //let requestURL = `${AUTH_SERVER}/auth/login`;
    let requestURL = `${AUTH_SERVER}/theodore/authtokens`;
    try {
        const result = yield call(Axios.post, requestURL, action.data);
        yield put(loginSuccess(result.data));
    } catch (err) { 
        const errorMessage =
            err.response?.data?.message || 
            "Something went wrong. Please try again.";

        yield put(loginFailure({ 
           errorMessage
        }));
    }
}
export function* theodoreLogin() {
    yield takeLatest(THEODORE_LOGIN, theoLogin);
}